<script lang="ts">
	// Formating
	import { format } from 'svelte-i18n';
	//Design system
	import { Text, Select, Row, Col, Button, IconButton } from '@Shelly/shelly-design-system';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	//Types
	import type { VirtualComponentInterface, VirtualComponentUI } from 'src/types/VirtualComponents';
	import VcEnumOptions from './VCEnumOptions.svelte';

	export let settings: VirtualComponentInterface['config'],
		editEnumModal = false;

	let configUI: VirtualComponentUI = settings?.meta?.ui || {};
	let selectedEnumIndex: number = 0;

	const viewOptions = [
		{
			title: capFirstChar(
				$format('virtual_component_label', {
					default: 'label',
				}),
			),
			value: 'label',
		},
		{
			title: capFirstChar(
				$format('virtual_component_label_dropdown', {
					default: 'dropdown',
				}),
			),
			value: 'dropdown',
		},
		{
			title: capFirstChar(
				$format('virtual_component_label_hidden', {
					default: 'hidden',
				}),
			),
			value: '',
		},
	];

	const createNewEnum = () => {
		selectedEnumIndex = settings.options?.length || 0;
		editEnumModal = true;
	};
	const editEnum = (i: number) => {
		selectedEnumIndex = i;
		editEnumModal = true;
	};
	const deleteEnum = (option: string, i: number) => {
		delete configUI.titles[option];
		settings.options.splice(i, 1);
		settings.options = settings.options;
		if (option == settings?.default_value) {
			settings.default_value = null;
		}
	};

	let defaultOptions = [];

	const changeDefaultOptions = (settings: VirtualComponentInterface['config']) => {
		defaultOptions = [
			{
				title: capFirstChar(
					$format('option_none', {
						default: 'none',
					}),
				),
				value: null,
			},
		];
		(settings?.options || []).forEach((i) => {
			defaultOptions.push({
				title: i,
				value: i,
			});
		});
	};

	$: changeDefaultOptions(settings);
</script>

{#if !editEnumModal}
	<Text styleType="h2" class="mb-s">
		{$format('virtual_component_title_view', {
			default: 'View',
		})}
	</Text>
	<Select
		aria-label={$format('select_view', { default: 'Select view' })}
		class="width-full mb-m"
		value={viewOptions.find((i) => i.value == settings?.meta?.ui?.view) || viewOptions[0]}
		options={viewOptions}
		icon="fas fa-eye"
		on:change={(e) => {
			settings.meta.ui.view = e.detail['value'];
		}}
		id="select-houuex4"
	/>

	<Text styleType="h2" class="mb-s">
		{$format('virtual_component_title_options', {
			default: 'Options',
		})}
	</Text>

	{#each settings?.options || [] as option, i}
		<Row>
			<Col sm="10" md="11" lg="11">
				<Button
					size="m"
					variant="secondary"
					width="full"
					class="mb-s"
					style="justify-content: start;padding-left: 7px;"
					icon="fas fa-file-pen"
					on:click={() => editEnum(i)}
				>
					{option} / {configUI?.titles?.[option] || ''}</Button
				></Col
			>
			<Col sm="2" md="1" lg="1" class="d-flex flex-auto justify-content-center">
				<IconButton
					aria-label={$format('button_delete', { default: 'Delete' })}
					icon={'fas fa-trash'}
					variant="danger"
					on:click={() => deleteEnum(option, i)}
				/>
			</Col>
		</Row>
	{/each}
	<Button size="m" class="mb-m" width="full" variant="secondary" on:click={createNewEnum}
		>{$format('button_add', { default: 'Add' })}</Button
	>

	<Text styleType="h2" class="mb-s">
		{$format('sub_settings_title_component_default_value', {
			default: 'Default Value',
		})}
	</Text>

	<Select
		aria-label={$format('select_default_value', { default: 'Select default value' })}
		options={defaultOptions}
		value={defaultOptions.find((i) => i.value == settings?.default_value) || defaultOptions[0].title}
		icon="fas fa-list"
		size="m"
		class="mb-m"
		on:change={(e) => {
			settings.default_value = e.detail['value'];
		}}
		id="select-i09jpey"
	/>
{:else}
	<VcEnumOptions bind:settings bind:editEnumModal {selectedEnumIndex} />
{/if}
